module.exports = __webpack_public_path__ + "media/images/smart_phone/to_fukidashi-78b6db16fa99d40d8d9214157d905d10.png";